<template>
    <div class="seller-center">
        <!-- 头部组件 -->
        <CenterHeader />
        <!-- 主体内容区域 -->
        <div class="main-content">
            <div class="container">
                <CenterLeft :menu-list="sellerMenuList" :default-active="currentComponent"
                    @menu-select="handleMenuSelect" />
                <div class="right-content">
                    <component :is="currentComponent" :certified="userInfo.certified" :key="componentKey" />
                </div>
            </div>
        </div>
        <!-- 底部组件 -->
        <Footer />
    </div>
</template>

<script>
import CenterHeader from './components/CenterHeader.vue'
import CenterLeft from './components/CenterLeft.vue'
import Footer from '../../components/Footer.vue'

// 异步加载卖家中心组件，提升初始加载性能
import SellerHome from './components/SellerComponents/SellerHome.vue'
import ShopOrders from './components/SellerComponents/ShopOrders.vue'
import AfterSalesOrders from './components/SellerComponents/AfterSalesOrders.vue'
import ProductManagement from './components/SellerComponents/ProductManagement.vue'
import PurchaseQuotes from './components/SellerComponents/PurchaseQuotes.vue'
import FinancialManagement from './components/SellerComponents/FinancialManagement.vue'

// 允许访问的组件列表，使用对象提高查找效率
const ALLOWED_COMPONENTS = {
    SellerHome,
    ShopOrders,
    AfterSalesOrders,
    ProductManagement,
    PurchaseQuotes,
    FinancialManagement,
}

export default {
    name: 'SellerCenter',
    components: {
        CenterHeader,
        CenterLeft,
        Footer,
        // 注册所有允许的组件
        ...ALLOWED_COMPONENTS
    },
    data() {
        return {
            userInfo: {},
            currentComponent: 'SellerHome', // 默认显示首页
            componentKey: 0, // 用于强制刷新组件
            componentParams: {} // 传递给组件的参数
        }
    },
    computed: {
        sellerMenuList() {
            const baseMenu = [{ index: 'SellerHome', label: '首页' }]
            const fullMenu = baseMenu.concat([
                { index: 'ShopOrders', label: '店铺订单' },
                { index: 'AfterSalesOrders', label: '售后订单' },
                { index: 'ProductManagement', label: '商品管理' },
                { index: 'PurchaseQuotes', label: '采购报价' },
                { index: 'FinancialManagement', label: '财务管理' },
                { index: 'PurchaseHall', label: '采购大厅' },
                { index: 'ShopBackstage', label: '商家后台' }
            ])
            return Number(this.userInfo.certified) === 5 ? fullMenu : baseMenu
        }
    },
    created() {
        // 从路由参数获取组件名称
        const componentName = this.$route.query.component || 'SellerHome'

        // 检查组件名是否在允许的列表中
        const allowedComponentNames = Object.keys(ALLOWED_COMPONENTS);
        if (allowedComponentNames.includes(componentName)) {
            this.currentComponent = componentName;
        }
    },
    mounted() {
        this.getUserShopStatus()
    },
    methods: {
        async getUserShopStatus() {
            try {
                const res = await this.$api.userInfo()
                this.userInfo = res
                this.$store.dispatch('updateUserInfo', res)
            } catch (err) {
                this.$message.warning('获取用户信息失败：' + (err.message || err))
            }
        },
        handleMenuSelect(componentName) {
             // 处理商家后台特殊情况，打开新网页
            if (componentName === 'ShopBackstage') {
                // 打开商家后台新网页
                window.open('https://app.bykjy.com/automatic/m13759.usershangjiaguanli_login/login', '_blank');
                return;
            }
             // 处理采购大厅特殊情况，跳转到首页采购大厅
            if (componentName === 'PurchaseHall') {
                // 跳转到首页采购大厅
                this.$router.push({
                    path: '/',
                    query: {
                        activeName: '3'
                    }
                });
                return;
            }
            // 只有当要切换的组件与当前组件不同时才执行切换
            if (this.currentComponent !== componentName) {
                this.currentComponent = componentName;
                this.componentKey += 1; // 强制刷新组件
                // 更新URL参数
                this.$router.push({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        component: componentName
                    }
                });
            }
        },
    }
}
</script>

<style scoped>
.seller-center {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #f5f5f5;
}

.main-content {
    flex: 1;
    padding: 20px 0;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    gap: 20px;
}

.right-content {
    flex: 1;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    padding: 20px;
}

@media (max-width: 768px) {
    .container {
        flex-direction: column;
    }

    .center-left {
        width: 100%;
    }

    .left-menu {
        display: flex;
        overflow-x: auto;
        white-space: nowrap;
    }

    ::v-deep .el-menu--vertical .el-menu-item {
        display: inline-block;
        border-left: none;
        border-bottom: 3px solid transparent;
    }

    ::v-deep .el-menu-item.is-active {
        border-left-color: transparent;
        border-bottom-color: #286CED;
    }
}

.center-left {
    flex-shrink: 0;
}
</style>